import { type RecruitmentEvaluationResponse } from '@on3/api';
import { handleKeyDown } from '@on3/ui-lib/utils/accessibility/keyDown';
import clsx from 'clsx';
import { format } from 'date-fns';
import { useState } from 'react';

import styles from './ScoutingJournalItem.module.scss';

export const ScoutingJournalItem = ({
  title,
  dateAdded,
  authorName,
  authorTitle,
  body,
}: RecruitmentEvaluationResponse) => {
  const [truncate, setTruncate] = useState<boolean>(true);

  return (
    <article className={styles.block}>
      <header>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.author}>
          <span className={styles.name}>{authorName}</span>
          {authorTitle && <span>{` • ${authorTitle}`}</span>}
        </p>
        <span className={styles.date}>
          {dateAdded && format(new Date(dateAdded), 'M/dd/yy')}
        </span>
      </header>
      {body.length > 400 ? (
        <div
          aria-expanded={truncate}
          className={clsx(styles.body, {
            [styles.clamp]: truncate,
          })}
          onClick={() => (!truncate ? null : setTruncate(!truncate))}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
        >
          <p>{body}</p>
        </div>
      ) : (
        <p className={styles.body}>{body}</p>
      )}
    </article>
  );
};
